import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { getUser } from './service/AuthService';

import './css/Daily.css';
import './css/Notifications.css';

const notificationsUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/notifications';

const Notifications = () => {
    const user = getUser();
    const [message, setMessage] = useState('');
    const navigate = useNavigate();
    const [enabled, setEnabled] = useState(false);

    const toggleChange = () => {
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        };

        const requestBody = {
            user: user,
            type: 'daily',
            enabled: !enabled
        };

        axios.post(notificationsUrl, requestBody, requestConfig).then(() => {
            setMessage('');
        }).catch((error) => {
            if (error.response?.status === 401 || error.response?.status === 403) {
                setMessage(error.response.data.message);
            } else {
                setMessage('Sorry the server is down. Please try again later.');
            }
        });

        setEnabled((prev) => !prev);
    };

    return (
        <div className="wrapper supportScreen">
            <div className="supportSurface">
                <div className="supportHeader">
                    <h2 className="dailyMainTitle">
                        Consistency is key <br />
                        in long-term change
                    </h2>
                    <p className="inDevelopmentCopy">
                        Gentle reminders can help you stay on track. Turn daily notifications on or off anytime.
                    </p>
                </div>

                <div className="supportSectionCard">
                    <h5 className="supportSectionTitle">Notification settings</h5>
                    {message ? (
                        <p className="notificationsInlineMessage" role="alert">
                            {message}
                        </p>
                    ) : null}
                    <div className="notificationToggleRow">
                        <span className="notificationToggleLabel">Daily notifications</span>
                        <label className="ios-toggle">
                            <input
                                type="checkbox"
                                checked={enabled}
                                onChange={toggleChange}
                            />
                            <span className="slider">
                                <span className="handle" />
                            </span>
                        </label>
                    </div>
                </div>

                <div className="homeBttnContainer supportActions">
                    <button
                        type="button"
                        className="homeBttn"
                        onClick={() => navigate('/settings')}
                    >
                        Back to settings
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Notifications;
